import { DataGrid } from '@mui/x-data-grid';
import axios from 'axios';
import { xapi } from '../../hooks/session';
import { IUser } from '../../models/user';
import { throwError } from '../helper';

/*
 * User
 */

export const getClassUserStatList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/class-stat/users?schoolSeq=${data.schoolSeq}&schoolGrade=${data.schoolGrade}&schoolClass=${data.schoolClass}&startDate=${data.startDate}&endDate=${data.endDate}&page=${data.page}&perPage=${data.rowsPerPage}&searchKey=${data.searchKey}&searchWord=${data.searchWord}&sortByNumber=${data.sortByNumber}&sortByFinish=${data.sortByFinish}&sortByAvg=${data.sortByAvg}&sortByTotal=${data.sortByTotal}&sortByWrite=${data.sortByWrite}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const deleteMemberSchoolClass = (data: any) =>
  xapi
    .put(`/admin/v1/apis/class-stat/member/withdraw`, {
      memberCodes: data.memberCodes,
    })
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

/*
 * Rank
 */
export const getClassReadRankList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/class-stat/rank/read?schoolSeq=${data.schoolSeq}&schoolGrade=${data.schoolGrade}&schoolClass=${data.schoolClass}&page=${data.page}&perPage=${data.rowsPerPage}&searchKey=${data.searchKey}&searchWord=${data.searchWord}&startDate=${data.startDate}&endDate=${data.endDate}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getClassWalkRankList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/class-stat/rank/walk?schoolSeq=${data.schoolSeq}&schoolGrade=${data.schoolGrade}&schoolClass=${data.schoolClass}&page=${data.page}&perPage=${data.rowsPerPage}&searchKey=${data.searchKey}&searchWord=${data.searchWord}&startDate=${data.startDate}&endDate=${data.endDate}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getClassWriteRankList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/class-stat/rank/write?schoolSeq=${data.schoolSeq}&schoolGrade=${data.schoolGrade}&schoolClass=${data.schoolClass}&page=${data.page}&perPage=${data.rowsPerPage}&searchKey=${data.searchKey}&searchWord=${data.searchWord}&startDate=${data.startDate}&endDate=${data.endDate}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const downloadClassRankList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/class-stat/rank/${data.type}/download?orderType=${data.orderType}&schoolSeq=${data.schoolSeq}&schoolGrade=${data.schoolGrade}&schoolClass=${data.schoolClass}&page=${data.page}&perPage=${data.rowsPerPage}&searchKey=${data.searchKey}&searchWord=${data.searchWord}&startDate=${data.startDate}&endDate=${data.endDate}`,
      { responseType: 'blob' }
    )
    .then(res => {
      const blob = new Blob([res.data]);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'class_stat_rank.xlsx';
      document.body.appendChild(a);
      a.click();
      setTimeout((_: any) => {
        window.URL.revokeObjectURL(url);
      }, 60000);
      a.remove();
    })
    .catch(err => {
      console.error('err: ', err);
    });

/*
 * Statistics
 */

export const getClassMonthlyReadRankList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/class-stat/monthly-rank/read?schoolSeq=${data.schoolSeq}&schoolGrade=${data.schoolGrade}&schoolClass=${data.schoolClass}&year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getClassMonthlyWalkRankList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/class-stat/monthly-rank/walk?schoolSeq=${data.schoolSeq}&schoolGrade=${data.schoolGrade}&schoolClass=${data.schoolClass}&year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getClassMonthlyWriteRankList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/class-stat/monthly-medal/write?schoolSeq=${data.schoolSeq}&schoolGrade=${data.schoolGrade}&schoolClass=${data.schoolClass}&year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getClassReadAchievementRank = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/class-stat/achievement-rank/read?schoolSeq=${data.schoolSeq}&schoolGrade=${data.schoolGrade}&schoolClass=${data.schoolClass}&year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getClassWalkAchievementRank = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/class-stat/achievement-rank/walk?schoolSeq=${data.schoolSeq}&schoolGrade=${data.schoolGrade}&schoolClass=${data.schoolClass}&year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getClassWriteAchievementRank = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/class-stat/achievement-rank/write?schoolSeq=${data.schoolSeq}&schoolGrade=${data.schoolGrade}&schoolClass=${data.schoolClass}&year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getClassDailyWalkAchievementRank = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/class-stat/daily-achievement-rank/walk?schoolSeq=${data.schoolSeq}&schoolGrade=${data.schoolGrade}&schoolClass=${data.schoolClass}&year=${data.year}&month=${data.month}&day=${data.day}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getClassDailyWriteAchievementRank = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/class-stat/daily-achievement-rank/write?schoolSeq=${data.schoolSeq}&schoolGrade=${data.schoolGrade}&schoolClass=${data.schoolClass}&year=${data.year}&month=${data.month}&day=${data.day}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getClassMonthlyReadAchievementData = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/class-stat/achievement-data/read?schoolSeq=${data.schoolSeq}&schoolGrade=${data.schoolGrade}&schoolClass=${data.schoolClass}&year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getClassMonthlyWalkAchievementData = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/class-stat/achievement-data/walk?schoolSeq=${data.schoolSeq}&schoolGrade=${data.schoolGrade}&schoolClass=${data.schoolClass}&year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getClassMonthlyWriteAchievementData = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/class-stat/achievement-data/write?schoolSeq=${data.schoolSeq}&schoolGrade=${data.schoolGrade}&schoolClass=${data.schoolClass}&year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getClassMonthlyMemberList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/class-stat/monthly-member?schoolSeq=${data.schoolSeq}&schoolGrade=${data.schoolGrade}&schoolClass=${data.schoolClass}&year=${data.year}&month=${data.month}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getClassMonthlyReadMedalList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/class-stat/monthly-medal/read?schoolSeq=${data.schoolSeq}&schoolGrade=${data.schoolGrade}&schoolClass=${data.schoolClass}&year=${data.year}&month=${data.month}&targetType=${data.targetType}&memberSeq=${data.memberSeq}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getClassMonthlyWalkMedalList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/class-stat/monthly-medal/walk?schoolSeq=${data.schoolSeq}&schoolGrade=${data.schoolGrade}&schoolClass=${data.schoolClass}&year=${data.year}&month=${data.month}&targetType=${data.targetType}&memberSeq=${data.memberSeq}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getClassMonthlyWriteMedalList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/class-stat/monthly-medal/write?schoolSeq=${data.schoolSeq}&schoolGrade=${data.schoolGrade}&schoolClass=${data.schoolClass}&year=${data.year}&month=${data.month}&targetType=${data.targetType}&memberSeq=${data.memberSeq}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getClassDailyWalkAchievementData = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/class-stat/daily-achievement-data/walk?schoolSeq=${data.schoolSeq}&schoolGrade=${data.schoolGrade}&schoolClass=${data.schoolClass}&year=${data.year}&month=${data.month}&day=${data.day}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getClassDailyWriteAchievementData = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/class-stat/daily-achievement-data/write?schoolSeq=${data.schoolSeq}&schoolGrade=${data.schoolGrade}&schoolClass=${data.schoolClass}&year=${data.year}&month=${data.month}&day=${data.day}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getClassYearReadAchievementData = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/class-stat/year-achievement-data/read?schoolSeq=${data.schoolSeq}&schoolGrade=${data.schoolGrade}&schoolClass=${data.schoolClass}&year=${data.year}&month=${data.month}&targetType=${data.targetType}&memberSeq=${data.memberSeq}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getClassYearWalkAchievementData = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/class-stat/year-achievement-data/walk?schoolSeq=${data.schoolSeq}&schoolGrade=${data.schoolGrade}&schoolClass=${data.schoolClass}&year=${data.year}&month=${data.month}&targetType=${data.targetType}&memberSeq=${data.memberSeq}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const getClassYearWriteAchievementData = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/class-stat/year-achievement-data/write?schoolSeq=${data.schoolSeq}&schoolGrade=${data.schoolGrade}&schoolClass=${data.schoolClass}&year=${data.year}&month=${data.month}&targetType=${data.targetType}&memberSeq=${data.memberSeq}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const downloadClassYearAchievementData = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/class-stat/year-achievement-data/${data.type}/${data.dataType}/download?schoolSeq=${data.schoolSeq}&schoolGrade=${data.schoolGrade}&schoolClass=${data.schoolClass}&year=${data.year}&month=${data.month}&targetType=${data.targetType}&memberSeq=${data.memberSeq}`,
      { responseType: 'blob' }
    )
    .then(res => {
      const blob = new Blob([res.data]);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'class_monthly_achievement.xlsx';
      document.body.appendChild(a);
      a.click();
      setTimeout((_: any) => {
        window.URL.revokeObjectURL(url);
      }, 60000);
      a.remove();
    })
    .catch(err => {
      console.error('err: ', err);
    });

export const downloadClassMonthlyDataList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/class-stat/monthly-rank/${data.type}/${data.dataType}/download?schoolSeq=${data.schoolSeq}&schoolGrade=${data.schoolGrade}&schoolClass=${data.schoolClass}&year=${data.year}&month=${data.month}`,
      { responseType: 'blob' }
    )
    .then(res => {
      const blob = new Blob([res.data]);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'class_monthly_rank.xlsx';
      document.body.appendChild(a);
      a.click();
      setTimeout((_: any) => {
        window.URL.revokeObjectURL(url);
      }, 60000);
      a.remove();
    })
    .catch(err => {
      console.error('err: ', err);
    });

export const downloadClassMonthlyMedalDataList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/class-stat/monthly-medal/${data.type}/${data.dataType}/download?schoolSeq=${data.schoolSeq}&schoolGrade=${data.schoolGrade}&schoolClass=${data.schoolClass}&year=${data.year}&month=${data.month}&targetType=${data.targetType}&memberSeq=${data.memberSeq}`,
      { responseType: 'blob' }
    )
    .then(res => {
      const blob = new Blob([res.data]);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'class_monthly_medal.xlsx';
      document.body.appendChild(a);
      a.click();
      setTimeout((_: any) => {
        window.URL.revokeObjectURL(url);
      }, 60000);
      a.remove();
    })
    .catch(err => {
      console.error('err: ', err);
    });

export const downloadClassDailyRwwDataList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/class-stat/daily-rww-data/download?schoolSeq=${data.schoolSeq}&schoolGrade=${data.schoolGrade}&schoolClass=${data.schoolClass}&page=${data.page}&perPage=${data.rowsPerPage}&searchKey=${data.searchKey}&searchWord=${data.searchWord}&startDate=${data.startDate}&endDate=${data.endDate}`,
      { responseType: 'blob' }
    )
    .then(res => {
      const blob = new Blob([res.data]);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'class_daily_member_rww.xlsx';
      document.body.appendChild(a);
      a.click();
      setTimeout((_: any) => {
        window.URL.revokeObjectURL(url);
      }, 60000);
      a.remove();
    })
    .catch(err => {
      console.error('err: ', err);
    });

export const downloadClassMonthlyMemberData = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/class-stat/monthly-member/download?schoolSeq=${data.schoolSeq}&schoolGrade=${data.schoolGrade}&schoolClass=${data.schoolClass}&year=${data.year}&month=${data.month}`,
      { responseType: 'blob' }
    )
    .then(res => {
      const blob = new Blob([res.data]);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'class_monthly_member.xlsx';
      document.body.appendChild(a);
      a.click();
      setTimeout((_: any) => {
        window.URL.revokeObjectURL(url);
      }, 60000);
      a.remove();
    })
    .catch(err => {
      console.error('err: ', err);
    });

/*
 * Log Manage
 */
export const getClassWriteList = (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/class-stat/all-write-status?schoolSeq=${data.schoolSeq}&schoolGrade=${data.schoolGrade}&schoolClass=${data.schoolClass}&page=${data.page}&perPage=${data.rowsPerPage}&searchKey=${data.searchKey}&searchWord=${data.searchWord}&startDate=${data.startDate}&endDate=${data.endDate}`
    )
    .then(res => {
      if (res.status !== 200) throwError(res.status);
      return res.data;
    });

export const downloadClassWriteList = async (data: any) =>
  xapi
    .get(
      `/admin/v1/apis/class-stat/all-write-status/download?schoolSeq=${data.schoolSeq}&schoolGrade=${data.schoolGrade}&schoolClass=${data.schoolClass}&page=${data.page}&perPage=${data.rowsPerPage}&searchKey=${data.searchKey}&searchWord=${data.searchWord}&startDate=${data.startDate}&endDate=${data.endDate}`,
      { responseType: 'blob' }
    )
    .then(res => {
      const blob = new Blob([res.data]);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'class_stat_log.xlsx';
      document.body.appendChild(a);
      a.click();
      setTimeout((_: any) => {
        window.URL.revokeObjectURL(url);
      }, 60000);
      a.remove();
    })
    .catch(err => {
      console.error('err: ', err);
    });
